<template>
    <v-container>
      <v-row>
        <v-col cols="12" v-if="!loading">
          O evento <strong>{{ event.title }}</strong> está fechado
        </v-col>
        <v-col cols="12">
            <a style="text-decoration: underline;" @click="$router.push('/')">
                Voltar à homepage
            </a>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
<script>
import Events from '@/api/Events.js';

export default{
    name: "EventIsClosed",
    data(){
        return{
            event: null,
            loading: true
        }
    },
    mounted(){
        this.fillBaseData()
    },
    methods:{
        async fillBaseData(){
            let data = await Events.get(this.$route.params.id);
            this.event = data.data
            this.loading = false
        }
    }
}

</script>
  
<style scoped>

.privacy-modal {
  border-radius: 10px;
  overflow-y: auto;
  max-height: 100vh;
}

.privacy-content {
  padding: 20px;
  overflow-y: auto;
  max-height: 50vh;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.privacy-content::-webkit-scrollbar {
  width: 10px;
}

.privacy-content::-webkit-scrollbar-track {
  display: none;
}

.privacy-content::-webkit-scrollbar-thumb {
  display: none;
}

 
  .container {
    margin-top: 5rem;
    margin-left: 5rem;
  }

  .title {
    font-weight: 600;
    font-size: 2.25rem !important;
    text-decoration: underline;
    font-family: 'Urbane Rounded', sans-serif !important;
  }

  .text_box {
    padding-top: 2rem;
    max-width: 475px;
  }

  .text {
    font-family: 'Urbane Rounded', sans-serif !important;
    font-weight: 500;
    font-size: 1.25rem !important;
    text-align: justify;
  }

  @media (max-width: 798px) {
    .container {
      margin-top: 1rem;
      margin-left: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 2rem;
    }

    .title {
      font-size: 1.2rem !important;
      text-decoration: none;
    }

    .text {
      font-size: 1rem !important;
    }

    .text_box {
      padding-top: 1rem !important;
    }
  }

  </style>